import {DataStatus} from 'platform/components';
import {Show, VStack} from 'platform/foundation';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetServiceOrderIntegrationsQuery} from '@dms/api/workshop';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useOrderAdditionalInformationSections} from '../../../../../pages/ServiceCaseDetail/hooks/useOrderAdditionalInformationSections';
import {OrderClaraInformation} from './OrderClaraInformation';
import {OrderEvaClaimInformation} from './OrderEvaClaimInformation';
import {OrderMazdaInformation} from './OrderMazdaInformation';

interface OrderDetailProps extends TestIdProps {
  orderId: string;
  serviceCaseId: string;
}

export function OrderDetailAdditionalInformation(props: OrderDetailProps) {
  const {
    data: serviceOrderIntegrations,
    isLoading: isServiceOrderIntegrationsLoading,
    isError: isServiceOrderIntegrationsError,
  } = useGetServiceOrderIntegrationsQuery(
    {
      serviceCaseId: props.serviceCaseId,
      serviceOrderId: props.orderId,
    },
    {skip: isNilOrEmpty(props.serviceCaseId) || isNilOrEmpty(props.orderId)}
  );

  const {
    isClaraVisible,
    isEvaVisible,
    isMazdaVisible,
    isLoading: isIntegrationsLoading,
    isError: isIntegrationsError,
  } = useOrderAdditionalInformationSections({
    serviceCaseId: props.serviceCaseId,
    orderId: props.orderId,
    orderIntegrations: serviceOrderIntegrations ?? {orderIntegration: []},
  });

  const isLoading = isServiceOrderIntegrationsLoading || isIntegrationsLoading;
  const isError = isServiceOrderIntegrationsError || isIntegrationsError;

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      <VStack spacing={1}>
        <Show when={isClaraVisible}>
          <OrderClaraInformation orderId={props.orderId} serviceCaseId={props.serviceCaseId} />
        </Show>
        <Show when={isEvaVisible}>
          <OrderEvaClaimInformation orderId={props.orderId} serviceCaseId={props.serviceCaseId} />
        </Show>
        <Show when={isMazdaVisible}>
          <OrderMazdaInformation
            orderId={props.orderId}
            serviceCaseId={props.serviceCaseId}
            data-testid={suffixTestId('mazdaInformation', props)}
          />
        </Show>
      </VStack>
    </DataStatus>
  );
}
